import React from 'react'
import classnames from 'classnames'
import debounce from 'lodash/debounce'
import { compose } from 'redux'
import { connect } from 'react-redux'
import Navigation from 'app/components/containers/Navigation'
import WhitelabelGridItem from 'app/components/dashboard/WhitelabelGridItem'
import { Layout, Flex, Container } from 'app/components/base/Layout'
import Loading from 'app/components/base/Loading'
import TextField from 'app/components/base/TextField'
import { withRouter } from 'react-router'
import { loadWhitelabelsListRequest } from 'app/redux-base/actions/whitelabelsList'
import requireAuth from 'app/components/HOCs/requireAuth'

import style from './style.module.css'

const PAGE_SIZE = 100

const LoadingContainer = () => {
  return (
    <Container align="center center" nowrap>
      <Flex className={style.loading}>
        <Loading size="large" />
      </Flex>
    </Container>
  )
}

export class DashboardPage extends React.Component {
  constructor(props) {
    super(props)
    const params = new URLSearchParams(props.location.search)
    this.state = {
      search: params.get('search') || '',
      page: Number(params.get('page')) || 1,
    }
  }

  UNSAFE_componentWillMount() {
    const { search, page } = this.state
    this.props.dispatch(loadWhitelabelsListRequest(search || undefined, page))
  }

  componentWillUnmount() {
    this.dispatchSearch.cancel()
  }

  updateQueryParams = ({ search, page }) => {
    const { history } = this.props
    const params = new URLSearchParams()
    if (search) {
      params.set('search', search)
    }
    if (page > 1) {
      params.set('page', page)
    }
    history.replace({ search: params.toString() })
  }

  dispatchSearch = debounce(search => {
    this.props.dispatch(loadWhitelabelsListRequest(search, 1))
  }, 300)

  handleSearchChange = e => {
    const { value } = e.target
    this.setState({ search: value, page: 1 })
    this.updateQueryParams({ search: value, page: 1 })
    this.dispatchSearch(value)
  }

  handlePageClick = page => () => {
    const { search } = this.state
    this.setState({ page })
    this.updateQueryParams({ search, page })
    this.props.dispatch(loadWhitelabelsListRequest(search, page))
  }

  getThumbnail = item =>
    item.thumbnail ? `${item.thumbnail}?${item.updated_at}` : undefined

  handleClickCreate = () => {
    const { history } = this.props
    history.push('/create')
  }

  handleClickPreview = name => () => {
    const wlUrl = `https://www.mozio.com/?wl=${name}`
    window.open(wlUrl, '_blank')
  }

  handleClickEdit = id => () => {
    const { history } = this.props
    history.push(`/configuration/${id}`)
  }

  renderPagination(totalPages, page) {
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    return (
      <div className={style.pagination__pages}>
        {pages.map(pageNumber => (
          <button
            key={pageNumber}
            type="button"
            className={classnames(style.pagination__page, {
              [style['pagination__page--active']]: pageNumber === page,
            })}
            onClick={this.handlePageClick(pageNumber)}
          >
            {pageNumber}
          </button>
        ))}
      </div>
    )
  }

  renderHeader(totalPages) {
    const { count } = this.props
    const { page } = this.state
    return (
      <Flex size="nogrow" className={style.header}>
        <Layout direction="row" nowrap align="start center">
          <Flex size="noshrink">
            <h1 className={style.header__title}>Whitelabels</h1>
            {Number.isFinite(count) && (
              <span className={style.header__count}>{count} total</span>
            )}
          </Flex>
          <Flex size="grow" className={style.header__pagination}>
            {totalPages > 1 && this.renderPagination(totalPages, page)}
          </Flex>
          <Flex size="noshrink" className={style.header__search}>
            <TextField
              icon="search"
              placeholder="Search"
              rectangle
              input={{
                value: this.state.search,
                onChange: this.handleSearchChange,
              }}
            />
          </Flex>
        </Layout>
      </Flex>
    )
  }

  renderWhitelabels() {
    const { items } = this.props
    const { search } = this.state
    const showEmptyMessage = !!search && items.length === 0

    return (
      <Layout direction="column" nowrap>
        <Container
          direction="row"
          wrap
          align="center start"
          className={style.grid}
        >
          {items.map(item => (
            <div className={style.grid__item} key={item.id}>
              <WhitelabelGridItem
                onClickPreview={this.handleClickPreview(item.name)}
                onClickEdit={this.handleClickEdit(item.id)}
                name={item.name}
                thumbnail={this.getThumbnail(item)}
                offline={!item.is_live}
              />
            </div>
          ))}
        </Container>
        {showEmptyMessage && (
          <div className={style.empty}>
            No whitelabels match &ldquo;{search}&rdquo;
          </div>
        )}
      </Layout>
    )
  }

  render() {
    const { loading, count } = this.props
    const totalPages = Math.max(1, Math.ceil((count || 0) / PAGE_SIZE))
    return (
      <Layout fill nowrap direction="column" className={style.container}>
        <Flex size="noshrink">
          <Navigation />
        </Flex>
        <Container
          size="grow"
          direction="column"
          nowrap
          className={style.dashboard}
        >
          {this.renderHeader(totalPages)}
          {loading ? <LoadingContainer /> : this.renderWhitelabels()}
        </Container>
      </Layout>
    )
  }
}

// TODO: move to Flow types
// DashboardPage.propTypes = {
//   items: PropTypes.arrayOf(PropTypes.object).isRequired,
//   dispatch: PropTypes.func.isRequired,
//   loading: PropTypes.bool,
// }

const mapStateToProps = state => ({
  items: state.whitelabelsList.data,
  count: state.whitelabelsList.count,
  loading: state.whitelabelsList.loading,
})

export default compose(
  withRouter,
  requireAuth(),
  connect(mapStateToProps)
)(DashboardPage)
